import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ProductImage from "../../assets/images/our-product.png";
import { getImageUrl, handleImageError } from "../../utils/imageUtils";
import { AddToCart } from "../../Services/CartService";

const OurProduct = ({ product }) => {
  const navigate = useNavigate();
  const [addingToCart, setAddingToCart] = useState(false);

  if (!product) {
    return null;
  }

  const handleCustomiseClick = () => {
    // Navigate to customize wheat page with productId as query parameter
    navigate(`/customize-wheat?productId=${product.id}`);
  };

  const handleAddToCart = async () => {
    try {
      setAddingToCart(true);

      const userId = localStorage.getItem('userId');

      if (!userId) {
        // Trigger Header's login modal
        const loginButton = document.querySelector('[data-bs-target="#loginModal"]');
        if (loginButton) {
          loginButton.click();
        }
        setAddingToCart(false);
        return;
      }

      const cartData = {
        productId: product.id,
        shoppingCartTypeId: 2,
        quantity: 1,
        price: product.price || 0,
        discountPrice: product.discountPrice || product.price || 0,
        totalPrice: product.discountPrice || product.price || 0,
        weight: 0,
        discountId: product.discountId || 0,
        attributesXml: (product.attributesXmlString && product.attributesXmlString.trim() != "")
          ? product.attributesXmlString.replaceAll('\r\n', '')
          : "<Catalog></Catalog>",
        userId: parseInt(userId)
      };

      const response = await AddToCart(cartData);

      if (response.status) {
        // Dispatch custom event to update cart count in header
        window.dispatchEvent(new Event('cartUpdated'));
        // You can add a success message or toast here
      } else {
        console.error('Failed to add to cart:', response.message);
        // You can add an error message or toast here
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      // You can add an error message or toast here
    } finally {
      setAddingToCart(false);
    }
  };

  // Check if product is custom product or Category 9 (Single Grain Flour-fixed)
  const isCustomProduct = product.isCustomProduct === true || product.categoryId === 9 || product.category?.id === 9;

  return (
    <div className={'product-box'}>
      <div className="img-wrapper mb_22">
        <img
          className={'img-fluid'}
          src={getImageUrl(product.path || product.image, ProductImage)}
          alt={product.name ?? "Our Product"}
          onError={(e) => handleImageError(e, ProductImage)}
          loading="lazy"
          decoding="async"
        />
      </div>
      <div className="content text-center">
        <h5 className={'fs_20 fw_500 text-color mb_8 '}>
          ₹ {product.discountPrice ?? product.price ?? "15.00"}
          {product.discount > 0 && (
            <span className="text-muted text-decoration-line-through ms-2">
              ₹ {product.price}
            </span>
          )}
        </h5>
        <p className={'fs_16 fw_400 text-color mb_32'}>
          {product.name ?? "Durum wheat (Triticum durum)"}
        </p>

        {isCustomProduct ? (
          <button
            className={'button btn-border'}
            onClick={handleAddToCart}
          >
            {addingToCart ? 'Adding...' : 'Add To Cart'}
          </button>
        ) : (
          <button className={'button btn-border'} onClick={handleCustomiseClick}> Customise </button>
        )}
      </div>
    </div>
  );
};

export default OurProduct;
